/**
 * Represents the names of all query parameters (all channels - currently only TPF and Leisure) that have a corresponding search filter.
 */
export enum FilterQueryParam {
    advert_id = 'advert-id',
    advertising_location = 'advertising-location',
    aggregated_trim = 'aggregatedTrim',
    annual_tax_cars = 'annual-tax-cars',
    axle_config = 'axle-config',
    battery_quick_time = 'battery-quick-time',
    battery_range = 'battery-range',
    battery_time = 'battery-time',
    bedroom_layout = 'bedroom-layout',
    berth = 'berth',
    body_type = 'body-type',
    boot_size_values = 'bootSizeValues',
    cab_type = 'cab-type',
    calc_deposit = 'calc-deposit',
    calc_mileage = 'calc-mileage',
    calc_term = 'calc-term',
    category = 'category',
    category_tag = 'category-tag',
    cc_from = 'cc-from',
    cc_to = 'cc-to',
    click_and_collect_available = 'click-and-collect-available',
    co2_emissions = 'co2-emissions',
    co2_emissions_cars = 'co2-emissions-cars',
    colour = 'colour',
    dealer = 'dealer',
    deposit = 'deposit',
    driver_position = 'driver-position',
    drivetrain = 'drivetrain',
    emission_class = 'emission-class',
    end_layout = 'end-layout',
    exclude_writeoff_categories = 'exclude-writeoff-categories',
    fuel_consumption = 'fuel-consumption',
    fuel_type = 'fuel-type',
    include_delivery_option = 'include-delivery-option',
    include_non_classified = 'include-non-classified',
    insurance_group = 'insuranceGroup',
    is_seller_defined_used = 'is-seller-defined-used',
    keywords = 'keywords',
    lat_long = 'lat-long',
    lease_in_stock = 'lease-in-stock',
    lease_product_type = 'lease-product-type',
    location = 'location',
    ma = 'ma',
    make = 'make',
    max_engine_power = 'max-engine-power',
    max_exterior_length = 'max-exterior-length',
    max_gross_trailer_weight = 'max-gross-trailer-weight',
    max_gross_vehicle_weight = 'max-gross-vehicle-weight',
    max_hours_used = 'max-hours-used',
    max_lease_monthly_price = 'max-lease-monthly-price',
    max_lease_monthly_price_ex_vat = 'max-lease-monthly-price-ex-vat',
    max_monthly_price = 'max-monthly-price',
    max_mtplm = 'max-mtplm',
    maximum_badge_engine_size = 'maximum-badge-engine-size',
    maximum_mileage = 'maximum-mileage',
    maximum_seats = 'maximum-seats',
    min_engine_power = 'min-engine-power',
    min_exterior_length = 'min-exterior-length',
    min_gross_trailer_weight = 'min-gross-trailer-weight',
    min_gross_vehicle_weight = 'min-gross-vehicle-weight',
    min_hours_used = 'min-hours-used',
    min_lease_monthly_price = 'min-lease-monthly-price',
    min_lease_monthly_price_ex_vat = 'min-lease-monthly-price-ex-vat',
    min_monthly_price = 'min-monthly-price',
    min_mtplm = 'min-mtplm',
    minimum_badge_engine_size = 'minimum-badge-engine-size',
    minimum_mileage = 'minimum-mileage',
    minimum_seats = 'minimum-seats',
    model = 'model',
    modified_customer = 'modifiedCustomer',
    new_car_has_deal = 'newCarHasDeal',
    ni_only = 'ni-only',
    only_delivery_option = 'only-delivery-option',
    only_writeoff_categories = 'only-writeoff-categories',
    page = 'page',
    part_ex_available = 'part-ex-available',
    poa = 'poa',
    postcode = 'postcode',
    price_from = 'price-from',
    price_search_type_monthly = 'monthly-price',
    price_search_type_total = 'total_price',
    price_to = 'price-to',
    quantity_of_doors = 'quantity-of-doors',
    radius = 'radius',
    retailer_id = 'retailer_id',
    seats_values = 'seats_values',
    seller_type = 'seller-type',
    sort = 'sort',
    style = 'style',
    sub_category = 'sub-category',
    sub_style = 'sub-style',
    supplied_price_from = 'supplied-price-from',
    supplied_price_to = 'supplied-price-to',
    term = 'term',
    trailer_axle_number = 'trailer_axle_number',
    transmission = 'transmission',
    ulez_compliant = 'ulez-compliant',
    vat_status = 'vat-status',
    wheelbase = 'wheelbase',
    with_digital_retailing = 'with_digital_retailing',
    year_from = 'year-from',
    year_to = 'year-to',
    yearly_mileage = 'yearly-mileage',
    zero_to_60 = 'zero-to-60',
}

export enum OtherQueryParams {
    bucket = 'bucket',
}
